module.exports = __webpack_public_path__ + "static/media/java_game_2d.c57ebc1c.md";